const tableHeader = ['Nome', 'Sigla', 'Consumo', 'Revenda', 'Contribuinte', 'Não Contribuinte', 'Editar', 'Excluir'];

const Tablecadastro = [
  {
    id: 'nome',
    title: 'Nome',
    type: 'text',
    placeholder: 'Informe o nome do Imposto ...',
  },
  {
    id: 'sigla',
    title: 'Sigla',
    type: 'text',
    placeholder: 'Informe a Sigla do Estado ...',
  },
  {
    id: 'consumo',
    title: 'Consumo',
    type: 'number',
    placeholder: 'Informe a % de consumo ...',
  },
  {
    id: 'revenda',
    title: 'Revenda',
    type: 'number',
    placeholder: 'Informe  a % de revenda ...',
  },
  {
    id: 'contribuinte',
    title: 'Contribuinte',
    type: 'number',
    placeholder: 'Informe  a % para contribuinte ...',
  },
  {
    id: 'naoContribuinte',
    title: 'Não Contribuinte',
    type: 'number',
    placeholder: 'Informe  a % para nao Contribuinte ...',
  },
];

const title = 'Cadastro de Impostos';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'imposto',
};
